// ============================================
// COMBINED PRODUCTS - Product ID to Handle Mapper
// Fetches product_id from page JSON and maps to handles
// ============================================

(function() {
  'use strict';
  
  // Global cache
  window.CombinedProducts = window.CombinedProducts || {};
  window.CombinedProducts.productMap = {};
  window.CombinedProducts.variantToProductMap = {};
  window.CombinedProducts.initialized = false;
  
  /**
   * Fetch current page product JSON to get variant product_ids
   */
  async function fetchCurrentProductVariants() {
    try {
      const currentPath = window.location.pathname;
      const response = await fetch(`${currentPath}.json`);
      
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }
      
      const data = await response.json();
      const product = data.product;
      
      product.variants.forEach(variant => {
        if (variant.product_id && variant.product_id !== product.id) {
          window.CombinedProducts.variantToProductMap[variant.id] = variant.product_id;
        }
      });
      
    } catch (error) {
      console.error('[Combined Products] Failed to fetch current product:', error);
    }
  }
  
  /**
   * Fetch all products and build the handle map
   */
  async function fetchAllProducts() {
    try {
      let allProducts = [];
      let page = 1;
      let hasMoreProducts = true;
      
      while (hasMoreProducts && page <= 5) {
        const response = await fetch(`/products.json?limit=250&page=${page}`);
        
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
        
        const data = await response.json();
        
        if (data.products && data.products.length > 0) {
          allProducts = allProducts.concat(data.products);
          page++;
          
          if (data.products.length < 250) {
            hasMoreProducts = false;
          }
        } else {
          hasMoreProducts = false;
        }
      }
      
      // Build map: product_id → handle
      allProducts.forEach(product => {
        window.CombinedProducts.productMap[product.id] = product.handle;
      });
      
    } catch (error) {
      console.error('[Combined Products] Failed to fetch all products:', error);
    }
  }
  
  /**
   * Initialize both maps
   */
  async function initialize() {
    if (window.CombinedProducts.initialized) {
      return;
    }
    
    await Promise.all([
      fetchCurrentProductVariants(),
      fetchAllProducts()
    ]);
    
    window.CombinedProducts.initialized = true;
  }
  
  /**
   * Get product_id for a variant_id
   */
  window.CombinedProducts.getProductId = function(variantId) {
    return window.CombinedProducts.variantToProductMap[variantId] || null;
  };
  
  /**
   * Get handle for a product_id
   */
  window.CombinedProducts.getHandle = function(productId) {
    if (!window.CombinedProducts.initialized) {
      return null;
    }
    
    const handle = window.CombinedProducts.productMap[productId];
    
    if (!handle) {
      console.warn(`[Combined Products] No handle found for product_id: ${productId}`);
    }
    
    return handle;
  };
  
  /**
   * Get URL for a variant_id (convenience function)
   */
  window.CombinedProducts.getUrlForVariant = function(variantId) {
    const productId = window.CombinedProducts.getProductId(variantId);
    
    if (!productId) {
      return null;
    }
    
    const handle = window.CombinedProducts.getHandle(productId);
    return handle ? `/products/${handle}` : null;
  };
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
  
})();
